(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/best-bet-rows/assets/javascripts/single-row.js') >= 0) return;  svs.modules.push('/components/pool-betting/best-bet-rows/assets/javascripts/single-row.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const Outcome = svs.components.lbUi.outcome.Outcome;
const signIndexToOutcome = svs.components.sport.tipsenShared.signIndexToOutcome;
const useBranding = svs.components.tipsen.hooks.useBranding;
const hasValidOutcomePair = svs.components.poolBetting.utils.hasValidOutcomePair;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const MATCHEN = svs.utils.products.productIds.MATCHEN;
const composeOutcomeLabel = _ref => {
  let _ref$outcome = _ref.outcome,
    outcome = _ref$outcome === void 0 ? [] : _ref$outcome,
    eventTypeId = _ref.eventTypeId,
    productId = _ref.productId;
  if (!Array.isArray(outcome)) {
    return '';
  }
  if (outcome.length === 1) {
    return signIndexToOutcome[eventTypeId][outcome[0]];
  }
  if (productId === MATCHEN) {
    return "".concat(outcome[0], " - ").concat(outcome[1]);
  }
  return "".concat(signIndexToOutcome[eventTypeId][outcome[0]], " - ").concat(signIndexToOutcome[eventTypeId][outcome[1]]);
};
const isSelected1X2 = _ref2 => {
  let resultOutcome = _ref2.resultOutcome,
    outcome = _ref2.outcome;
  if (!resultOutcome || !resultOutcome.length) {
    return false;
  }
  return parseInt(parseInt(resultOutcome[0], 10), 10) === outcome;
};
const isSelected = _ref3 => {
  let outcome = _ref3.outcome,
    resultOutcomes = _ref3.resultOutcomes,
    index = _ref3.index,
    eventTypeId = _ref3.eventTypeId;
  let isSelected;
  switch (eventTypeId) {
    case EventTypeId.RESULT:
      isSelected = hasValidOutcomePair({
        outcomePairs: [outcome.join('-')],
        resultOutcome: resultOutcomes === null || resultOutcomes === void 0 ? void 0 : resultOutcomes[index],
        maxOutcomeIndex: 10
      });
      break;
    case EventTypeId.EVENT_1X2:
      isSelected = isSelected1X2({
        resultOutcome: resultOutcomes === null || resultOutcomes === void 0 ? void 0 : resultOutcomes[index],
        outcome: outcome[0]
      });
      break;
    default:
      isSelected = false;
  }
  return isSelected;
};
const SingleRow = React.memo(_ref4 => {
  let className = _ref4.className,
    eventTypeId = _ref4.eventTypeId,
    productId = _ref4.productId,
    resultOutcomes = _ref4.resultOutcomes,
    rowNumber = _ref4.rowNumber,
    rowOutcomes = _ref4.rowOutcomes,
    topic = _ref4.topic;
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  return React.createElement("div", {
    className: ['pb_best_bet_rows__row'].concat(className || []).join(' ')
  }, rowNumber && React.createElement("div", {
    className: "pb_best_bet_rows__row_header"
  }, rowNumber), React.createElement("div", {
    className: "pb_best_bet_rows__row_topic"
  }, topic), React.createElement("div", {
    className: "pb_best_bet_rows__row_outcomes"
  }, rowOutcomes.map((outcome, index) =>
  React.createElement("div", {
    className: "pb_best_bet_rows__row_outcome_container",
    key: "pb_best_bet_rows__row_outcome_container_".concat(outcome).concat(index)
  }, React.createElement(Outcome, {
    branding: productBranding,
    className: "pb_best_bet_rows__row_outcome",
    isSelected: isSelected({
      outcome,
      resultOutcomes,
      index,
      eventTypeId
    })
    ,
    key: "".concat(outcome).concat(index),
    sign: composeOutcomeLabel({
      outcome,
      eventTypeId,
      productId
    })
  })))));
}, (prevProps, nextProps) => prevProps.rowOutcomes.join('') === nextProps.rowOutcomes.join('') && prevProps.resultOutcomes.join('') === nextProps.resultOutcomes.join('') && prevProps.topic === nextProps.topic && prevProps.className === nextProps.className);
setGlobal('svs.components.poolBetting.bestBetRows.SingleRow', SingleRow);

 })(window);